'use client';

import { Star } from '@velocity-exchange/icons';
import React, { memo } from 'react';
import { cj } from 'src/utils/classNames';

const FavouriteButton = ({
	highlighted,
	onClick,
	className,
	wrapperClassName,
	starSizePx = 16,
}: {
	highlighted: boolean;
	onClick: React.MouseEventHandler<HTMLDivElement>;
	className?: string;
	wrapperClassName?: string;
	starSizePx?: number;
}) => {
	return (
		<div
			className={cj(
				'flex items-center justify-center hover:cursor-pointer',
				wrapperClassName
			)}
			onClick={(e) => onClick(e)}
		>
			<div
				className={cj(
					'flex items-center justify-center hover:cursor-pointer',
					highlighted ? 'text-star-yellow' : 'text-text-disabled',
					className
				)}
			>
				<Star size={starSizePx} />
			</div>
		</div>
	);
};

export default memo(FavouriteButton);
